// TODO: REPLACE THIS WITH A CONTEXT PROVIDER
// EVERYTHING IN `VIEWER.JS` COULD USE THIS FOR APPROPRIATE CONTEXT
import CTToolbarRow from './CTToolbarRow';
import { connect } from 'react-redux';
import { getActiveContexts } from './../store/layout/selectors.js';
import { redux as apiRedux } from '../api';

const { setDatadictLocationLabels } = apiRedux.actions;

const mapStateToProps = state => {
  return {
    activeContexts: getActiveContexts(state),
    applicationInfo: state.api.current.applicationInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLocationLabelsUpdated: data => dispatch(setDatadictLocationLabels(data)),
  };
};

const ConnectedCTToolbarRow = connect(
  mapStateToProps,
  mapDispatchToProps
)(CTToolbarRow);

export default ConnectedCTToolbarRow;
